exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".element[data-v-2493918e]::after {\n  display: block;\n  content: \"\";\n  clear: both;\n}\n.unemplyed_flg[data-v-2493918e] {\n  font-size: 12px;\n}\n.fx[data-v-2493918e] {\n  align-items: center;\n  display: flex;\n}\n.fx label[data-v-2493918e] {\n  margin-bottom: 0;\n}\n.fx span[data-v-2493918e] {\n  margin: 0 10px;\n}\n.mg_tb_10[data-v-2493918e] {\n  margin: 10px 0;\n}\n.next[data-v-2493918e] {\n  margin-top: 40px;\n  text-align: center;\n}\n.next .el-button[data-v-2493918e] {\n  border-radius: 0;\n  padding-left: 30px;\n  padding-right: 30px;\n}", ""]);

// exports
